var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quality-recommend"},[_vm._m(0),_c('Promotion-good',{attrs:{"benefit":_vm.goodsList}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title acea-row row-center-wrapper"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"name"},[_c('span',{staticClass:"iconfont icon-cuxiaoguanli"}),_vm._v("促销单品\n    ")]),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }